import en from './locales/en.json';
import de from './locales/de.json';

export const accountsLocales = {
  en: { accounts: en },
  de: { accounts: de },
};

export { accountsRoutes } from './routes';
export { default as AccountsPage } from './pages/AccountsPage.vue';
export { useAccountCreation } from './composables/useAccountCreation';
export { useAccountsActivityStore } from './store/accounts-activity.store';
export type { AccountsActivityItem } from './store/accounts-activity.store';
